import { useEffect } from 'react';
import { createDispatchHook, useDispatch } from 'react-redux';
import { updateConfig } from '../../slices/configDetails';
import { StoreContext } from '../../context/store';
import { resetState as resetPersonalDetailsState } from '../../slices/personalDetails';
import { resetState as resetCitizenshipDetailsState } from '../../slices/citizenshipDetails';
import { resetState as resetContactDetailsState } from '../../slices/contactDetails';
import { resetState as resetAddressDetailsState } from '../../slices/addressDetails';
import { startAgain } from 'actionCreators/config';
import { setSelectedLoanInfo } from 'actionCreators/calculator';

const useCustomerInformationStoreSelector = createDispatchHook(StoreContext);

export const JourneyInformationHOC = (props) => {
  const { journey, resetCustomerInfo, setResetCustomerInfo } = props;
  const dispatch = useDispatch();
  const custInfoDispatch = useCustomerInformationStoreSelector();

  useEffect(() => {
    custInfoDispatch(updateConfig({ journey }));
  }, [custInfoDispatch, journey]);

  useEffect(() => {
    if (resetCustomerInfo) {
      dispatch(startAgain(true));
      dispatch(setSelectedLoanInfo({}));
      custInfoDispatch(resetPersonalDetailsState());
      custInfoDispatch(resetCitizenshipDetailsState());
      custInfoDispatch(resetContactDetailsState());
      custInfoDispatch(resetAddressDetailsState());
      setResetCustomerInfo(false);
    }
  }, [custInfoDispatch, resetCustomerInfo]);

  return props.children;
};
